import React, { useState, useEffect } from "react";
import { TabButtonFlatButton } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import {
  Accounts,
  BusinessProfile,
  Documents,
  IdManager,
  ProxyManagement,
  Team,
} from "./components";

const AgencyProfileDisplay = ({
  data,
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [tableDisplay, setTableDisplay] = useState("profile");

  return (
    <div
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ position: "fixed", top: 29, display: "flex" }}>
        <div style={{ marginLeft: 10 }}>
          <TabButtonFlatButton
            title={"BUSINESS PROFILE"}
            backgroundColor={
              tableDisplay === "profile"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "profile"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("profile")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"DOCUMENTS"}
            backgroundColor={
              tableDisplay === "docs"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "docs" ? colors.secondaryDarkBlue : colors.white
            }
            onClick={() => setTableDisplay("docs")}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"TEAM"}
            backgroundColor={
              tableDisplay === "team"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "team" ? colors.secondaryDarkBlue : colors.white
            }
            onClick={() => setTableDisplay("team")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"ACCOUNT"}
            backgroundColor={
              tableDisplay === "account"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "account"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("account")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"IDS"}
            backgroundColor={
              tableDisplay === "ids"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "ids" ? colors.secondaryDarkBlue : colors.white
            }
            onClick={() => setTableDisplay("ids")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"PROXY MANAGEMENT"}
            backgroundColor={
              tableDisplay === "proxyManagent"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "proxyManagent"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("proxyManagent")}
          />
        </div>
      </div>
      {tableDisplay === "profile" ? (
        <BusinessProfile
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {tableDisplay === "docs" ? (
        <Documents
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {tableDisplay === "team" ? (
        <Team
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {tableDisplay === "account" ? (
        <Accounts
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {tableDisplay === "ids" ? (
        <IdManager
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {tableDisplay === "proxyManagent" ? (
        <ProxyManagement
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setPopUpTitle={setPopUpTitle}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
    </div>
  );
};
export default AgencyProfileDisplay;
